import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Card } from 'antd';

import { convertirTextAMomentUTC, MASCARA_DDMMYYYY, MASCARA_YYYYMMDD } from '../../commons/gestioDates';
import { textQuanNoHiHaDada } from '../../constants';

class ObservacioDadesEstacio extends Component {

    renderObservador(observadors) {

        if (!observadors || observadors.length === 0) {
            return textQuanNoHiHaDada;
        }

        return observadors.map((observador, index) => {
            return <div key={observador.id + '-' + index} className='observacio-detall-observadors-observador'>{observador.nom} {observador.cognom1}</div>;
        });
    }

    render() {
        const estacio = this.props.estacio;

        const dataAlta = convertirTextAMomentUTC(estacio.dataAlta, MASCARA_YYYYMMDD);
        const dataAltaText = dataAlta ? dataAlta.format(MASCARA_DDMMYYYY) : null;

        return (
            <Card id='dades_basiques'>
                <div className='observacio-detall-element observacio-detall-codi'><span>Codi:</span>{estacio.codi}</div>
                <div className='observacio-detall-element observacio-detall-nom'><span>Nom:</span>{estacio.nom}</div>
                <div className='observacio-detall-element observacio-detall-data-alta'><span>{'Data d\'alta:'}</span>{dataAltaText}</div>
                <div className='observacio-detall-element observacio-detall-comarca'><span>Comarca:</span>{estacio.comarca}</div>
                <div className='observacio-detall-element observacio-detall-municipi'><span>Municipi:</span>{estacio.municipi}</div>
                <div className='observacio-detall-element observacio-detall-observadors'>
                    <span className='observacio-detall-observadors-titol'>Observador/s:</span>{this.renderObservador(estacio.observadors)}
                </div>
            </Card>
        );
    }
}

ObservacioDadesEstacio.propTypes = {
    estacio: PropTypes.object
};

export default ObservacioDadesEstacio;



// WEBPACK FOOTER //
// ./src/components/observacio/observacioDadesEstacio.js